import { mountComponents, unmountAllComponents } from './core/mount';

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountComponents);
} else {
  mountComponents();
}

const unmountButton = document.getElementById('unmountButton');
if (unmountButton) {
  unmountButton.addEventListener('click', unmountAllComponents);
}

export { mountComponents, unmountAllComponents };
